import React from 'react';
import { OverlayTrigger, Tooltip, Overlay, Popover } from 'react-bootstrap';

export default class FormTextareaNew extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      initialValue: props.value ? props.value : '',
      value: props.value ? props.value : '',
      focused: false,
    };

    this.inputRef = React.createRef();
  }

  checkFocused = () => {
    return this.state.focused ? 'focused ' : '';
  };

  checkRequired = () => {
    return this.props.meta.validate.rules.indexOf('required') !== -1 ? 'required ' : '';
  };

  checkError = () => {
    return this.props.validation.valid ? '' : 'has-error ';
  };

  checkAccess = () => {
    return this.props.meta.acl.read;
  };

  checkReadOnly = () => {
    return !this.props.meta.acl.write;
  };

  catchFocus = () => {
    this.inputRef.current.focus();
  };

  onChange = (value) => {
    this.setState({ value });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.props.onChange(this.props.name, value);
    }, 150);
  };

  onBlur = (value) => {
    this.setState({ focused: false, value });
    this.props.onBlur(this.props.name, value);
  };

  checkDisabled = () => {
    const { disabled, meta } = this.props;
    if (disabled) {
      return true;
    }
    if (!meta.acl.write) {
      return true;
    }
    return false;
  };

  setValue = (value) => {
    this.setState({ value });
    this.onChange(value);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.state.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  render() {
    const { label, name, validation, infoText, placeholder, maxLength } = this.props;
    const { value } = this.state;

    return (
      <div
        className={
          'form-group form-group-default ' +
          this.checkFocused() +
          this.checkRequired() +
          this.checkError() +
          (this.checkDisabled() ? 'disabled ' : '')
        }
        onClick={this.catchFocus}
      >
        <label className="d-flex justify-content-between align-items-center w-100">
          <span>
            {label}
            {!!infoText && (
              <span className="m-l-5">
                <OverlayTrigger placement="top" overlay={<Tooltip>{infoText}</Tooltip>}>
                  <i className="far fa-question-circle cursor-help" />
                </OverlayTrigger>
              </span>
            )}
          </span>

          {!!maxLength && (
            <span
              className={`extra-small ${value.length >= maxLength ? 'text-danger fw-bold' : 'text-muted'}`}
              style={{ fontSize: '10px' }}
            >
              {value.length} / {maxLength}
            </span>
          )}
        </label>

        <textarea
          ref={this.inputRef}
          value={value || ''}
          type={this.props.type}
          className="form-control"
          name={name}
          maxLength={maxLength || undefined}
          onChange={(e) => this.onChange(e.target.value)}
          onFocus={() => this.setState({ focused: true })}
          onBlur={(e) => this.onBlur(e.target.value)}
          disabled={this.checkDisabled()}
          style={{ width: '100%', height: 'auto' }}
          rows={this.props.rows}
          placeholder={placeholder}
        />

        {!validation.valid && (
          <Overlay show={this.state.focused} target={this.inputRef.current} placement="top">
            <Popover className="popover-modal" id={`error_${name}_${label}`}>
              {validation.helpText}
            </Popover>
          </Overlay>
        )}
      </div>
    );
  }
}

FormTextareaNew.defaultProps = {
  label: '',
  meta: { validate: { rules: '' }, acl: { read: true, write: true } },
  validation: { valid: true },
  value: '',
  onChange: () => {},
  onBlur: () => {},
  disabled: false,
  infoText: '',
  rows: 8,
  placeholder: '',
  maxLength: null,
};
